var $b18f1cccd66ace6e$exports = {};
$b18f1cccd66ace6e$exports = {
    "more": `Altri elementi`
};


export {$b18f1cccd66ace6e$exports as default};
//# sourceMappingURL=it-IT.mjs.map
